export var ErrorKeys;
(function (ErrorKeys) {
    ErrorKeys["SENTRY_NOT_CONFIGURED"] = "sentry_not_configured";
})(ErrorKeys || (ErrorKeys = {}));
